import { Pipe, PipeTransform } from '@angular/core';
import { LMFormatUtilService } from '@services/utils';

@Pipe({
  name: 'booleanAsSwitchTooltip',
  standalone: false
})
export class LMBooleanAsSwitchTooltipPipe implements PipeTransform {

  constructor(private lmFormatUtilService: LMFormatUtilService) { }

  // used to display a tooltip for a checkbox display as switch when the control is readOnly
  transform(triggerValue: boolean, value: string, isReadOnly: boolean): string {
    if (isReadOnly) {
      return this.lmFormatUtilService.booleanToDisplay(value);
    }
    return '';
  }
}
